export default "__VITE_PUBLIC_ASSET__2de3850b__"